const timetable = [
  {
    path: '/timetable/overview',
    component: () => import('@/page/timetable/Overview.vue'),
    meta: {
      name: '월별 근무 기록',
      isMenu: false,
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/timetable/record',
    component: () => import('@/page/timetable/Record.vue'),
    meta: {
      name: '일별 근무 기록',
      isMenu: false,
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/timetable/current',
    component: () => import('@/page/timetable/Current.vue'),
    meta: {
      name: '근무 현황',
      isMenu: false,
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/timetable/manage',
    component: () => import('@/page/timetable/Manage.vue'),
    meta: {
      name: '마감 관리',
      isMenu: false,
      isActive: false,
      isBread: true,
    },
  }
];

export default timetable;
